export default __webpack_public_path__ + "static/armony-plus-5-8ece05094494f2065f5924a9a6cb30b8.jpg";